import React from 'react';
import { ActionButton } from '@fluentui/react';

export interface IBwjLinkButtonProps {
  text: string;
  icon?: string;
  onClick: Function;
}

export const BwjLinkButton: React.FunctionComponent<IBwjLinkButtonProps> = (props) => {

  return (
    <ActionButton
      iconProps={!!props.icon ? { iconName: props.icon} : undefined}
      onClick={() => props.onClick()}
    >
      {props.text}
    </ActionButton>
  );
};
